<template>
  <div class="editor" style="position:relative;">
  
    <editor-menu-bar  :style="focusedStyle" :editor="editor" v-slot="{ commands, isActive }" >
      <div class="menubar">

       <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <icon name="bold"/>
        </button>

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
         <icon name="italic"/>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
         <icon name="paragraph"/>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >H1
        </button>
         <button
          class="menububble__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >H2
        </button>
         <button
          class="menububble__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >H3
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <icon name="checklist" />
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.todo_list() }"
          @click="commands.todo_list"
        >
          <icon name="checklist" />
        </button>
         <button
          class="menububble__button"
          :class="{ 'is-active':  isActive.showCode }"
          @click="showCode=!showCode"
        >
        <icon name="code" />
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': showCode }"
          @click="doSave(html)"
        >
        <icon name="upload" />
        </button>
      </div>
    </editor-menu-bar>
   
<div ref="slot" style="display:none;"><slot ></slot></div>
<div style="display:flex;flex-direction: row;align-items: flex-start">
    <div v-if="showField" class="fieldText">{{field}}&nbsp;:-</div>
    <editor-content class="editor__content" :editor="editor" >
        </editor-content>
   <input v-if="showCode" v-model="html" style="width:100%;">  
  </div>
  </div>
</template>

<script>
import Icon from '../components/Icon'
import { Editor, EditorContent, EditorMenuBubble, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  components: {
    EditorContent,
    EditorMenuBubble,
    EditorMenuBar,
    Icon
    
  },
  props: ["collection","textID","saveText",'field','showField'],
  data() {
    return {
      html:null,
      json:null,
      showCode:false,
      keepInBounds: true,
      editor: null,
      showMenu:false,
    }
  },
  mounted(){
      this.editor=new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem({
            nested: true,
          }),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.slotText
        ,
        onUpdate: ({ getJSON, getHTML }) => {
          this.json = getJSON()
          this.html = getHTML()
        },
      })  
      this.html = this.editor.getHTML()    
    },
    computed:{
        focusedStyle(){
          if(!this.showMenu){
            return "opacity:0;pointer-events:none;"
          }
        },
        textElement(){
            return this.$store.getters.getTextElement({collection:this.collection,doc:this.textID})
        },
        textBody(){
            if(this.textElement){
                return this.textElement[this.field]
            }
        },
        loading(){
            return this.$store.getters.loading
        },
        slotText(){
            if(this.textBody){
                return this.textBody
            }
            return this.$refs.slot.innerHTML
        },
      focused(){
        if(this.editor){
          return this.editor.focused
        }
        
      }
    },
    methods:{
      doSave(html){
          if(this.saveText){
              this.saveText(html)
          }else if(this.textID){
            this.$store.dispatch("saveText",{collection:this.collection,doc:this.textID,field:this.field,content:html})
       
             // this.$store.dispatch("saveSpecificText",{type:this.textID,content:html})
          }
      },
      hideMenu(){
        if(!this.focused){
          this.showMenu=false
        }

      }

    },
    watch:{
      focused(val){
        if(val){
          this.showMenu=true;
        }else{
          setTimeout(this.hideMenu,1000)
          
        }
      },
        textBody(){
            this.editor.setContent(this.textBody)
        },
       loading(val){
           this.$nextTick().then(() => {
                if(this.textBody){
                    }else{
                this.editor.setContent(this.$refs.slot.innerHTML)
                }
           })
       }
    },
  beforeDestroy() {
    if(this.editor){
       this.editor.destroy()
    }
  },
}
</script>
<style lang="scss">
.blue{
  background-color:#00f;
}
.green{
  background-color:#42b983;
}
.editor__content{
  vertical-align:top;
    display: inline-block;
    color:inherit;
    p,ul{
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    }
}
.fieldText{
  display: inline-block;
   
    margin-right:5px;
    vertical-align: top;
   
}
.menububble__button {
    height: 14px;
    position:relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: #fff;
    padding: .2rem .5rem;
    margin-right: .2rem;
    border-radius: 3px;
    cursor: pointer;
}

 .menububble {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    z-index: 20;
    background: #000;
    border-radius: 5px;
    padding: .3rem;
    margin-bottom: .5rem;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: opacity .2s,visibility .2s;
    transition: opacity .2s,visibility .2s;
  
  
}
.menububble.is-active {
    opacity: 1;
    visibility: visible;
}
h1, h2, h3{
  margin-bottom:0px;
}
ul[data-type="todo_list"] {
  margin-top:0px;
  padding-top:0px;
  padding-left: 0;
}
li[data-type="todo_item"] {
  display: flex;
  flex-direction: row;
}
.todo-checkbox {
  border: 2px solid #fff;
  height: 20px;
  width:20px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-top: 20px;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  border-radius: 0.2em;
  background-color: transparent;
  transition: 0.4s green;
}
.todo-content {
  font-size:18px;
  flex: 1;
}
.todo-content > p:last-of-type {
    margin-bottom: 0;
}
.todo-content > ul[data-type="todo_list"] {
    margin: .5rem 0;
}
li[data-done="true"] > .todo-content > p {
      text-decoration: line-through;
}

li[data-done="true"] > .todo-checkbox {
    background-color: #42b983;
}

li[data-done="false"] {
  text-decoration: none;
}
.menubar{
  position:absolute;
  top:-35px;
  opacity:.9;
  z-index:2;
  border:#fff 1px solid;
  background-color: #000;
    margin-bottom: 1rem;
    -webkit-transition: visibility .2s .4s,opacity .2s .4s;
    transition: visibility .2s .4s,opacity .2s .4s;
}
.menubar__button{
  background-color: #000;
}
</style>